// @ngInject
function ShippingMethodsApiService(ResourcesService) {

  var endpoint = 'shippingmethods';

  return {
    getShippingMethods: ResourcesService.apiFactory.get(endpoint),
    getShippingMethod: ResourcesService.apiFactory.get(endpoint),
    getLanguages: ResourcesService.apiFactory.get(endpoint + '/languages'),
    createShippingMethod: ResourcesService.apiFactory.create(endpoint, 'ShippingMethod'),
    updateShippingMethod: ResourcesService.apiFactory.update(endpoint, 'ShippingMethod'),
    deleteShippingMethod: ResourcesService.apiFactory.delete(endpoint, 'ShippingMethod')
  };

}

angular
  .module('shippingmethods.api', [])
  .factory('ShippingMethodsApiService', ShippingMethodsApiService);
